import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";

export default function VerifyOtp() {

  const [otp,setOtp] = useState("");
  const [error,setError] = useState("");
  const [loading,setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;

  const verifyOtp = async () => {

    if(!otp){
      setError("Please enter OTP");
      return;
    }

    try{

      setLoading(true);
      setError("");
      await axiosInstance.post("/password/verifyotp", {
       email:email,
        otp:otp
      });
      navigate("/reset-password",{state:{email}});
    }catch(err){
       alert("Invalid or expired OTP");
    }
    finally{
      setLoading(false);
    }

  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
         {loading && <Loader />}
      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md">

        <h2 className="text-2xl font-bold text-center mb-4">
          Verify OTP
        </h2>

        <p className="text-gray-600 text-sm text-center mb-6">
          Enter the OTP sent to your email,Will be valid for 5 min
        </p>

        {error && (
          <div className="bg-red-100 text-red-600 text-sm p-2 rounded mb-4">
            {error}
          </div>
        )}

        <input
          type="text"
          placeholder="Enter OTP"
          className="w-full px-4 py-2 border rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
          onChange={(e)=>setOtp(e.target.value)}
        />

        <button
          onClick={verifyOtp}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
        >
          {loading ? "Verifying..." : "Verify OTP"}
        </button>

      </div>

    </div>
  );
}